// src/App.js
import React, { Suspense, useEffect } from "react";
import { BrowserRouter, useRoutes } from "react-router-dom";
import { AuthProvider } from "./context/authContext"; // ✅ import AuthProvider
import Router from "./routes/Router";
import "./index.css";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AdminContextProvider from "./context/AdminContext";
import BankContextProvider from "./context/BankContext";
import SubTransactionProvider from "./context/SubTransactionContext";

import { App as CapacitorApp } from '@capacitor/app'
import {Capacitor} from '@capacitor/core'
function AppRoutes() {
  const routes = useRoutes(Router);
  return routes;
}

function App() {
  //back button logic
  useEffect(() => {
    let appListener;
    const setupListener = async () => {
      const isAndroid = Capacitor.getPlatform() === 'android';
      appListener = await CapacitorApp.addListener('backButton', ({ canGoBack }) => {
        const rootPath = ['/', '/login', 'register','/library-dashboard','/library-admin'];

        const currentPath = window.location.pathname;
  
        const isOnRootPath = rootPath.includes(currentPath);
        const canNavigaetBack = window.history.length > 1;
        if(isAndroid && isOnRootPath){
            if (window.confirm('Are you sure you want to exit the application?')) {
                CapacitorApp.exitApp();
            }        
        }else if (canNavigaetBack) {
          window.history.back();
        } else {
          //falback
          if (window.confirm('Are you sure you want to exit?')) {
            CapacitorApp.exitApp();
          }
        }
      });
    };

    setupListener();

    return () => {
      if (appListener) {
        appListener.remove();
      }
    };
  }, []);

  return (
    <BrowserRouter>
      <SubTransactionProvider>
        <BankContextProvider>
          <AdminContextProvider>
            <AuthProvider>
              <Suspense fallback={<div>Loading...</div>}>
                <AppRoutes />
              </Suspense>
            </AuthProvider>
          </AdminContextProvider>
        </BankContextProvider>
      </SubTransactionProvider>
      <ToastContainer position="top-right" autoClose={3000} />
    </BrowserRouter>
  );
}

export default App;
